/**
 * NT-VIERTEL-07-FEINSCHLIFF (B5) — deutsche Dealer-Status-Labels für die Ecken-Zeile im
 * Viertel-Tab (Muster: crimeOps.ts::getDealerStatusLabel, dort dasselbe Duplikat für die
 * Dealer-Karte — kein Shared-Import zwischen den beiden Seiten, etabliertes Repo-Pattern).
 * Ausgelagert in eine eigene Datei für Testbarkeit (Muster: viertel-presence-actions.ts).
 */

export type DealerStatusKey = 'ACTIVE' | 'PAUSED' | 'TRAINING' | 'ARRESTED' | 'FLEEING' | 'GONE';

export const DEALER_STATUS_LABELS_DE: Record<DealerStatusKey, string> = {
  ACTIVE: 'AKTIV',
  PAUSED: 'PAUSIERT',
  TRAINING: 'IN SCHULUNG',
  ARRESTED: 'VERHAFTET',
  FLEEING: 'ABGEHAUEN',
  GONE: 'ABGEHAUEN',
};

/** Übersetzt einen rohen Dealer-Status; unbekannte/leere Werte kommen unverändert zurück
 * (defensiver Fallback, kein Crash bei einem künftigen, hier noch nicht gepflegten Enum-Wert). */
export function getDealerStatusLabelDe(rawStatus: string): string {
  return (DEALER_STATUS_LABELS_DE as Record<string, string>)[rawStatus] ?? rawStatus;
}
